import { useEffect, useMemo, useState } from 'react'
import { FolderTree } from 'lucide-react'
import Modal from '../../components/Modal'
import DataTable from '../../components/DataTable'
import PageLoader from '../../components/PageLoader'
import { ErrorState } from '../../components/States'
import { getDataSourceGroups, sourceName } from './settingsService'
import { advancedStrings as S, common as C } from './strings'
import { serverDetail } from '../../lib/i18n'

/** A profile field's own label — the same words the profile settings use for it. */
const fieldLabel = (name) => S.profile.fields.find((field) => field.name === name)?.label ?? name

export default function DataSourceGroupsModal({ source, onClose }) {
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!source) return
    let active = true
    setLoading(true)
    setError(null)

    getDataSourceGroups(source.id)
      .then((res) => {
        if (!active) return
        if (res.ok) {
          setGroups(res.data ?? [])
        } else {
          setError(serverDetail(res.message) || C.saveFailed)
        }
      })
      .catch((err) => {
        if (active) setError(err.message || C.saveFailed)
      })
      .finally(() => {
        if (active) setLoading(false)
      })

    return () => {
      active = false
    }
  }, [source])

  /* What the directory returns for a department: the two names its users carry — the same
     pair sync matches a department by, and places each user in. */
  const columns = useMemo(
    () => [
      {
        key: 'arabicName',
        header: fieldLabel('ArabicName'),
        render: (row) => <bdi>{row.arabicName}</bdi>,
      },
      {
        key: 'englishName',
        header: fieldLabel('EnglishName'),
        render: (row) => <bdi>{row.englishName}</bdi>,
      },
    ],
    [],
  )

  const title = `${S.sources.browseGroups} - ${sourceName(source)}`

  return (
    <Modal open={Boolean(source)} onClose={onClose} title={title} icon={FolderTree} size="lg">
      {loading && <PageLoader />}
      {!loading && error && <ErrorState title={error} />}
      {!loading && !error && (
        <DataTable
          columns={columns}
          rows={groups}
          getRowId={(row) => row.id}
          emptyMessage={S.sources.noGroupsFound}
        />
      )}
    </Modal>
  )
}
